export default {
  heading: {
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    fontWeight: '400'
  },
  text: {
    lineHeight: 'body',
    fontFamily: 'body',
    fontWeight: 'body',
    fontSize: '1rem',
    color: 'text'
  },
  navLink: {
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading'
  },
  link: {
    textDecoration: 'none',
    color: 'unset'
  }
}
